const orderGetters = {
  getOrders: (state) => state.orders,
  getOrder: (state) => state.order,
  getNewOrderItems: (state) => state.orderStats
}

export { orderGetters }
